import { Component, Inject, OnInit, HostListener, ViewChild, TemplateRef} from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { AppSettingService, AppUtilityService } from '../app.service';
import { UserInfoService } from '../user/user-info.service';
import { InterestSurveyResultService, InterestSurveyAPIService } from './interest-survey.service';


@Component({
	selector: 'app-interest-survey',
	templateUrl: './interest-survey.component.html',
	styleUrls: ['./interest-survey.scss'],
	standalone: false
})
export class InterestSurveyComponent implements OnInit {
	constructor(
		private resultSrv: InterestSurveyResultService,
		private router: Router,
		private dialog: MatDialog
	) { }

	showMore: boolean = false;
	retrievingData: boolean = true;
	surveyCompleted: boolean = false;

	toggled: boolean = AppSettingService.widgetMobile();
	isMobile: boolean = AppSettingService.widgetMobile();
	private hasLoaded: boolean = false;

	private setDisplay():void {
		this.isMobile = AppSettingService.widgetMobile();
		this.toggled = !this.isMobile ? false : this.toggled;
		if (window.innerWidth <= 1023) {
			this.tooltipValues = {
				retake: 'Retake',
				results: 'Results',
				edit: 'Edit'
			};
		}
		else {
			this.tooltipValues = {
				retake: '',
				results: '',
				edit: ''
			};
		}
		this.ngOnInit();
	}

	toggleCollapse() {
		this.toggled = !this.toggled;
		this.ngOnInit();
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.setDisplay();
	}

	startSurvey(e: any): void {
		this.router.navigateByUrl("/InterestSurvey/Question");
	};

	toggleShowMore():void {
		this.showMore = !this.showMore;
	}

	editScores(e: any, reset: any): void {
		const popup = this.dialog.open(
			InterestSurveyEditScoreDialog,
			{
				disableClose: true,
				maxHeight: "90vh",
				maxWidth: "95vw",
				width: "850px",
				panelClass: 'jmDialog',
				data: {
					resetSurvey: reset,
				}
			}
		);
		popup.afterClosed().subscribe(
			choice => {
				if (choice === "save") {
					this.retrievingData = true;
					this.getScore();
				}
			}
		);
	}

	//#regiion display result
	RIASECObjs:any = null;
	tooltipValues = {
		retake: '',
		results: '',
		edit: ''
	};

	readMore(result:any) {
		const popup = this.dialog.open(
			InterestResultReadMoreDialog,
			{
				panelClass: 'jmDialog',
				maxWidth: '95vw',
				width: '850px',
				data: result
			}
		);
		popup.afterClosed().subscribe(
			choice => {
				;
			}
		);
	}

	surveyResult(e: any):void {
		this.router.navigateByUrl("/InterestSurvey/Result");
	}

	hasRecommendedSOC: boolean = false;
	private getScore() {
		this.showMore = false;
		this.resultSrv.getLastRIASEC().subscribe({
			next: (response: any) => {
				this.retrievingData = false;
				this.hasRecommendedSOC = response.HasRecommendedSOC;
				this.surveyCompleted = response != null && response !== 'no score' ? true : false;
				if (this.surveyCompleted) {
					let scores: number[] = response.ScoreList.split(',').map((x: any) => parseInt(x));
					this.RIASECObjs = this.resultSrv.createRIASECObjs(scores);
					// re-order RIASECObjs to display higher score first
					this.RIASECObjs = this.RIASECObjs.sort((a: any, b: any) => { return b.value - a.value; });
				}
			},
			error: (error: any) => {
				this.surveyCompleted = false;
				this.retrievingData = false;
			}
		});
	}
	//#endregiion display result

	ngOnInit(): void {
		if (this.hasLoaded === false) {
			if (this.RIASECObjs == null && !this.toggled) {
				this.hasLoaded = true;
				this.getScore();
			}
		}
	}
} 


@Component({
	template:`
		<div style="padding: 20px;">
			<div class="float-end">
				<span role="button" (click)="close()" class="jmCloseBtn"></span>
			</div>
			<div style="display: flex; justify-content: space-between;">
				<div style="display: flex; align-content: center;">
					<div>
						<i class="{{result.iconFont}}" style="font-size: 25px; color: var(--bs-secondary); padding-right:10px;"></i>
					</div>
					<div style="font-weight: 700;">
						{{result.label}}  ({{result.value}})
					</div>
				</div>
			</div>
			<div style="margin: 20px 0 10px 0">
				<div>{{result.description}}</div>
			</div>
			<div>
				<div>{{result.detailedDescription}}</div>
			</div>
		</div>`,
	standalone: false
})
export class InterestResultReadMoreDialog {
	result: any = null;
	constructor(
		public dialogRef: MatDialogRef<InterestResultReadMoreDialog>,
		@Inject(MAT_DIALOG_DATA) private data: any
	) {
		this.result = data;
	}

	close() {
		this.dialogRef.close(null);
	}
}


@Component({
	templateUrl: './interest-survey-edit-score.dialog.html',
	styleUrls: ['./interest-survey.scss'],
	standalone: false
})
export class InterestSurveyEditScoreDialog implements OnInit {
	resetSurvey: boolean = false;
	
	constructor(
		private userInfo: UserInfoService,
		private dialogRef: MatDialogRef<InterestSurveyEditScoreDialog>,
		@Inject(MAT_DIALOG_DATA) private data: any,
		private interestAPI: InterestSurveyAPIService,
		private interestResultSrv: InterestSurveyResultService
	) {
		this.resetSurvey = data?.resetSurvey??false;
	}

	interestsMobileDisplay: boolean = (window.innerWidth <= 425) ? true : false;

	@HostListener('window:resize', ['$event']) onResize(e: any): void {
		this.interestsMobileDisplay = (window.innerWidth <= 425) ? true : false;
	}

	
	RIASECObjs: any = null;
	hasTakenSurvey: boolean = false;
	hasData: boolean = false;
	saving: boolean = false;
	surveyResults: number[] = [];
	editButtonText: string = "Edit Scores"; //Change to show survey results

	showFace:any = {
		Realistic: false,
		Investigative: false,
		Artistic: false,
		Social: false,
		Enterprising: false,
		Conventional: false,
	};

	private defaultScores: number[] = [25, 25, 25, 25, 25, 25];
	styleDict: Record<string, any> = {
		Realistic: { widthAdjs: "62.5%", img: "assets/images/InterestSurvey/4_LikeIt.gif", percent: "62.5%", visible: true },
		Investigative: { widthAdjs: "62.5%", img: "assets/images/InterestSurvey/4_LikeIt.gif", percent: "62.5%", visible: true },
		Artistic: { widthAdjs: "62.5%", img: "assets/images/InterestSurvey/4_LikeIt.gif", percent: "62.5%", visible: true },
		Social: { widthAdjs: "62.5%", img: "assets/images/InterestSurvey/4_LikeIt.gif", percent: "62.5%", visible: true },
		Enterprising: { widthAdjs: "62.5%", img: "assets/images/InterestSurvey/4_LikeIt.gif", percent: "62.5%", visible: true },
		Conventional: { widthAdjs: "62.5%", img: "assets/images/InterestSurvey/4_LikeIt.gif", percent: "62.5%", visible: true }
	};

	calcPercent(val: number): number {
		//This assumes that the maximum score for a given dimension is 40
		//Divide by $scope.surveyTotal if you want to change to a weighted %
		return parseInt((val / 40 * 100).toString());
	}

	onSliderOut(e: any, obj: any): void {
		e.target.blur();
		this.styleDict[obj.label].visible = false;
	}

	onSliderChange(v: number, obj:any) {
		this.initializeSlider(obj);
		this.styleDict[obj.label].visible = true;
	}

	onSliderChanging(e: any, obj: any) {
		this.initializeSlider(obj);
		this.styleDict[obj.label].visible = true;
	}

	private initializeSlider(obj: any) {
		let img: string = "";
		if (obj.value < 8) {
			img = "assets/images/InterestSurvey/1_Dislike.gif";
		}
		else if (8 <= obj.value && obj.value < 16) {
			img = "assets/images/InterestSurvey/2_Meh.gif";
		}
		else if (16 <= obj.value && obj.value < 24) {
			img = "assets/images/InterestSurvey/3_Unsure.gif";
		}
		else if (24 <= obj.value && obj.value < 32) {
			img = "assets/images/InterestSurvey/4_LikeIt.gif";
		}
		else if (32 <= obj.value) {
			img = "assets/images/InterestSurvey/5_LoveIt.gif";
		}
		this.styleDict[obj.label] = {
			widthAdjs: this.interestResultSrv.calcPercent(obj.value).toString() + "%",
			img: img,
			percent: this.interestResultSrv.calcPercent(obj.oldValue).toString() + "%"
		};
	}

	//this is here to be used when user is anonymous, so we can transform resoponse data from service to look like data from API for processResults function
	private rawScoresToFormattedScores(rawScores: any): any {
		return [{
			Scores: [
				{ ScoreName: "R", Value: rawScores[0] },
				{ ScoreName: "I", Value: rawScores[1] },
				{ ScoreName: "A", Value: rawScores[2] },
				{ ScoreName: "S", Value: rawScores[3] },
				{ ScoreName: "E", Value: rawScores[4] },
				{ ScoreName: "C", Value: rawScores[5] }
			]
		}];
	};

	private processResults(response: any): void {
		if (response[0] === undefined) {
			this.editButtonText = "Enter Scores";
			this.surveyResults = this.defaultScores;
		}
		else {
			this.hasData = true;
			this.hasTakenSurvey = true;
			this.surveyResults = [response[0].Realistic, response[0].Investigative, response[0].Artistic, response[0].Social, response[0].Enterprising, response[0].Conventional];
		}
		this.createRIASECObjs(true);
	}

	changeScore(obj:any): void {
		this.initializeSlider(obj);
	}

	private edit() {
		this.saving = true;
		let R = (document.getElementById("Realistic") as HTMLInputElement);
		let I = (document.getElementById("Investigative") as HTMLInputElement);
		let A = (document.getElementById("Artistic") as HTMLInputElement);
		let S = (document.getElementById("Social") as HTMLInputElement);
		let E = (document.getElementById("Enterprising") as HTMLInputElement);
		let C = (document.getElementById("Conventional") as HTMLInputElement);

		if (this.editButtonText === "Save") {
			if (R.value.trim().length === 0 || I.value.trim().length === 0 || A.value.trim().length === 0 ||
				S.value.trim().length === 0 || E.value.trim().length === 0 || C.value.trim().length === 0) {
				Swal.fire("Oops", "The score entered must be a number between 0 and 40", "error")
				this.saving = false;
				return;
			}

			let saveObject = {
				Realistic: R.value,
				Investigative: I.value,
				Artistic: A.value,
				Social: S.value,
				Enterprising: E.value,
				Conventional: C.value,
				ManualEntry: true
			}

			this.interestAPI.saveRIASECScore(saveObject).subscribe({
				next: (response: any) => {
					this.surveyResults = [parseInt(R.value), parseInt(I.value), parseInt(A.value), parseInt(S.value), parseInt(E.value), parseInt(C.value)];
					if (response.Code === "202") {
						Swal.fire("Oops!", "It seems that we are having problems reaching the server.  Don't worry, we will keep trying and send you a notification when the data is available.", "info")
							.then(() => {
								this.dialogRef.close("save");
							});
					}
					else {
						this.dialogRef.close("save");
					}
				},
				error: (err: any) => {
					let msg: string = "Sorry, fail to save scores. Please rview and retry";
					if (err != null && err.error != null && err.error.Detail != null) {
						msg = err.error.Detail;
					}
					Swal.fire("Oops", msg, "error")
					this.saving = false;
				}
			});
		}
		else {
			R.value = R.getAttribute("defaultScore");
			I.value = I.getAttribute("defaultScore");
			A.value = A.getAttribute("defaultScore");
			S.value = S.getAttribute("defaultScore");
			E.value = E.getAttribute("defaultScore");
			C.value = C.getAttribute("defaultScore");
			this.editButtonText = "Save";
			if (!this.hasTakenSurvey) {
				this.surveyResults = this.defaultScores;
				this.createRIASECObjs(false);
			}
			this.saving = false;
		}
	}

	private createRIASECObjs(goEdit: boolean): void {
		if (this.surveyResults.length == 0) {
			return;
		}
		this.RIASECObjs = this.interestResultSrv.createRIASECObjs(this.surveyResults);
		this.RIASECObjs.forEach((obj: any) => { this.initializeSlider(obj); });
		if (goEdit) {
			setTimeout(() => { this.edit(); });
		}
	}

	modalCancel() {
		this.dialogRef.close("cancel");
	};

	modalSave() {
		this.edit();
	};

	ngOnInit(): void {
		if (this.resetSurvey === false) {
			if (this.userInfo.isAnonymous()) {
				this.processResults(this.rawScoresToFormattedScores(this.interestResultSrv.getResults()));
			}
			else {
				this.interestAPI.getMyLastResult().subscribe({
					next: (response: any) => {
						this.processResults(response);
					}
				});
			}
		}
		else {
			this.hasData = true;
			this.hasTakenSurvey = false;
			this.surveyResults = this.defaultScores;
			this.createRIASECObjs(true);
		}
	}
}
